export const receiptLedgerVersion = "strategy-receipt-ledger-0.1.0";

const countableCorpusSourceIds = [
  "pg-sunzi-giles-1910",
  "pg-song-celestial-arnold-1900",
  "pg-tao-teh-king-legge-1891",
  "pg-dhammapada-muller-1881",
  "pg-bushido-nitobe-1908",
  "pg-prince-machiavelli-marriott-1908",
  "pg-on-war-clausewitz-graham-1874",
  "pg-meditations-marcus-aurelius",
  "pg-leviathan-hobbes-1651"
];

const corpusRegistrySourceIds = [
  ...countableCorpusSourceIds,
  "ctext-sunzi",
  "ctext-seven-military-classics",
  "ctext-guiguzi",
  "ctext-i-ching",
  "shambhala-cleary-strategy-guide",
  "shambhala-cleary-i-ching-guide",
  "recovered-glyph-cleary-audit",
  "recovered-glyph-equation-registry",
  "recovered-glyph-validation-sources"
];

const equationSourceIds = [
  "pg-sunzi-giles-1910",
  "pg-tao-teh-king-legge-1891",
  "pg-dhammapada-muller-1881",
  "pg-bushido-nitobe-1908",
  "pg-prince-machiavelli-marriott-1908",
  "pg-on-war-clausewitz-graham-1874",
  "pg-meditations-marcus-aurelius",
  "pg-leviathan-hobbes-1651",
  "ctext-sunzi",
  "ctext-seven-military-classics",
  "ctext-guiguzi",
  "ctext-i-ching",
  "shambhala-cleary-strategy-guide",
  "shambhala-cleary-i-ching-guide",
  "recovered-glyph-cleary-audit",
  "recovered-glyph-equation-registry",
  "recovered-glyph-validation-sources"
];

export const receiptLedger = [
  {
    id: "public-domain-math-counts-latest",
    type: "corpus_extraction",
    path: "corpus/outputs/public-domain-math-counts.json",
    producedBy: "npm run extract:corpus",
    sourceIds: countableCorpusSourceIds,
    tracked: true,
    productionClaim: false,
    claimBoundary:
      "Extraction receipt counts only local public-domain custody files and excludes Cleary, CTEXT, and unverified sources."
  },
  {
    id: "corpus-custody-index-latest",
    type: "corpus_registry",
    path: "corpus/registry/corpus-custody-index.json",
    producedBy: "npm run registry:corpus",
    sourceIds: corpusRegistrySourceIds,
    tracked: true,
    productionClaim: false,
    claimBoundary:
      "Corpus custody index is generated registry evidence only and permits count claims only for local public-domain files with matching hashes."
  },
  {
    id: "corpus-intake-index-latest",
    type: "corpus_intake_registry",
    path: "docs/corpus/corpus-intake-index.json",
    producedBy: "npm run registry:intake",
    sourceIds: [],
    tracked: true,
    productionClaim: false,
    claimBoundary:
      "Corpus intake index is a lawful source-review queue only and does not count, ingest, or redistribute new source text."
  },
  {
    id: "semantic-review-packet-latest",
    type: "semantic_extraction_registry",
    path: "docs/extraction/semantic-review-packet.json",
    producedBy: "npm run registry:semantic",
    sourceIds: countableCorpusSourceIds,
    tracked: true,
    productionClaim: false,
    claimBoundary:
      "Semantic review packet turns local spot checks into reviewer queues and operator candidates only; it does not claim semantic proof or predictive accuracy."
  },
  {
    id: "equation-lifecycle-index-latest",
    type: "equation_lifecycle_registry",
    path: "docs/equations/equation-lifecycle-index.json",
    producedBy: "npm run registry:equations",
    sourceIds: equationSourceIds,
    tracked: true,
    productionClaim: false,
    claimBoundary:
      "Equation lifecycle index records operator-model governance only and does not claim formal verification or production prediction quality."
  },
  {
    id: "equation-lifecycle-receipt-latest",
    type: "equation_lifecycle_receipt",
    path: "docs/receipts/latest-equation-lifecycle-receipt.json",
    producedBy: "npm run receipt:equations",
    sourceIds: equationSourceIds,
    tracked: true,
    productionClaim: false,
    claimBoundary:
      "Equation lifecycle receipt proves local operator-governance custody only and does not grant formal proof, prediction quality, or professional-advice authority."
  },
  {
    id: "domain-readiness-index-latest",
    type: "domain_readiness_registry",
    path: "docs/domains/domain-readiness-index.json",
    producedBy: "npm run registry:domains",
    sourceIds: [],
    tracked: true,
    productionClaim: false,
    claimBoundary:
      "Domain readiness index proves local configuration alignment only and does not claim professional advice, live-data validation, or autonomous authority."
  },
  {
    id: "domain-readiness-receipt-latest",
    type: "domain_readiness_receipt",
    path: "docs/receipts/latest-domain-readiness-receipt.json",
    producedBy: "npm run receipt:domains",
    sourceIds: [],
    tracked: true,
    productionClaim: false,
    claimBoundary:
      "Domain readiness receipt proves local adapter, policy, score-policy, and module alignment only and does not grant professional advice or autonomous authority."
  },
  {
    id: "empirical-validation-index-latest",
    type: "empirical_validation_registry",
    path: "docs/validation/empirical-validation-index.json",
    producedBy: "npm run registry:validation",
    sourceIds: [],
    tracked: true,
    productionClaim: false,
    claimBoundary:
      "Empirical validation index records reviewed fixtures and metrics only and does not claim predictive accuracy."
  },
  {
    id: "empirical-validation-receipt-latest",
    type: "empirical_validation_receipt",
    path: "docs/receipts/latest-empirical-validation-receipt.json",
    producedBy: "npm run receipt:validation",
    sourceIds: [],
    tracked: true,
    productionClaim: false,
    claimBoundary:
      "Empirical validation receipt proves reviewed fixture custody only and does not claim predictive accuracy, formal verification, or held-out validation."
  },
  {
    id: "durable-custody-index-latest",
    type: "durable_custody_registry",
    path: "docs/custody/durable-custody-index.json",
    producedBy: "npm run registry:custody",
    sourceIds: [],
    tracked: true,
    productionClaim: false,
    claimBoundary:
      "Durable custody index records D1/R2/KV contracts and migration custody only; it does not claim server custody until Cloudflare bindings and write/read proof exist."
  },
  {
    id: "server-custody-smoke-latest",
    type: "server_custody_smoke",
    path: "docs/custody/server-custody-smoke.json",
    producedBy: "npm run custody:smoke",
    sourceIds: [],
    tracked: true,
    productionClaim: false,
    claimBoundary:
      "Server custody smoke records blocked status or live append/readback proof only; it cannot claim server custody unless every smoke gate passes."
  },
  {
    id: "cloudflare-resolution-status-latest",
    type: "deployment_blocker_resolution_status",
    path: "docs/deployment/cloudflare-resolution-status.json",
    producedBy: "npm run cloudflare:resolution",
    sourceIds: [],
    tracked: true,
    productionClaim: false,
    claimBoundary:
      "Cloudflare resolution status diagnoses blocker ownership only; it does not create resources, prove deployment, or claim server custody."
  },
  {
    id: "cloudflare-blocker-resolution-runbook",
    type: "deployment_blocker_resolution_runbook",
    path: "docs/deployment/cloudflare-blocker-resolution.md",
    producedBy: "manual blocker-resolution research and account-action plan",
    sourceIds: [],
    tracked: true,
    productionClaim: false,
    claimBoundary:
      "Cloudflare blocker runbook is an action plan and source boundary record only; it does not prove live Cloudflare deployment."
  },
  {
    id: "production-alpha-readiness-latest",
    type: "production_alpha_readiness",
    path: "docs/production-alpha/production-alpha-readiness.json",
    producedBy: "npm run registry:production-alpha",
    sourceIds: [],
    tracked: true,
    productionClaim: false,
    claimBoundary:
      "Production alpha readiness packet records implementation controls and blockers only; it does not claim production readiness without live deployment, custody, validation, and security proof."
  },
  {
    id: "security-threat-model-latest",
    type: "security_threat_model",
    path: "docs/security/threat-model-index.json",
    producedBy: "npm run registry:security",
    sourceIds: [],
    tracked: true,
    productionClaim: false,
    claimBoundary:
      "Security threat model records controls and proof gates only; it is not a penetration test, certification, or third-party attestation."
  },
  {
    id: "deployment-readiness-latest",
    type: "deployment_readiness",
    path: "docs/deployment/latest-readiness.json",
    producedBy: "npm run receipt:release",
    sourceIds: [],
    tracked: true,
    productionClaim: false,
    claimBoundary:
      "Deployment readiness packet proves local build/config readiness only and does not claim Cloudflare deployment, live URL, or rollback execution."
  },
  {
    id: "deployment-receipt-latest",
    type: "deployment_receipt",
    path: "docs/receipts/latest-deployment-receipt.json",
    producedBy: "npm run receipt:deployment",
    sourceIds: [],
    tracked: true,
    productionClaim: false,
    claimBoundary:
      "Deployment receipt records local missing-proof status only and does not claim Cloudflare deployment, live URL, or rollback execution."
  },
  {
    id: "release-receipt-latest",
    type: "release_receipt",
    path: "docs/receipts/latest-release-receipt.json",
    producedBy: "npm run verify:release",
    sourceIds: countableCorpusSourceIds,
    tracked: true,
    productionClaim: false,
    claimBoundary:
      "Release receipt is local deploy-ready evidence only and does not prove Cloudflare deployment or live URL health."
  },
  {
    id: "strategy-goal-audit-2026-06-20",
    type: "goal_audit",
    path: "docs/audits/strategy-goal-audit-2026-06-20.md",
    producedBy: "manual completion audit after npm run verify:release",
    sourceIds: [],
    tracked: true,
    productionClaim: false,
    claimBoundary:
      "Goal audit documents verified local state and explicit expansion blockers; it is not a production deployment, corpus-completion, or formal-proof claim."
  },
  {
    id: "strategy-long-term-implementation-audit-2026-06-20",
    type: "implementation_audit",
    path: "docs/audits/strategy-long-term-implementation-audit-2026-06-20.md",
    producedBy: "implementation audit after long-term plan tranche",
    sourceIds: [],
    tracked: true,
    productionClaim: false,
    claimBoundary:
      "Implementation audit records the expanded local Strategy OS governance state and does not claim live deployment, full-corpus completion, or formal proof."
  }
];

export function receiptLedgerSummary(ledger = receiptLedger) {
  return ledger.reduce(
    (summary, entry) => {
      summary.total += 1;
      summary[entry.type] = (summary[entry.type] ?? 0) + 1;
      if (entry.tracked) summary.tracked += 1;
      if (entry.productionClaim) summary.productionClaims += 1;
      return summary;
    },
    { total: 0, tracked: 0, productionClaims: 0 }
  );
}
